import React, {} from 'react';

const IDMCurve = (props) => {
    return(<div></div>)
}

export default IDMCurve